import { GA_SCRIPT_TAG_ID } from './ensureGAScriptAdded';

export const removeGAScript = () => {
  const elem = document.getElementById(GA_SCRIPT_TAG_ID);
  if (elem) {
    document.body.removeChild(elem);
  }
};
